import Tabby from 'tabbyjs';

const mediaQuery = window.matchMedia('(min-width: 992px)');

// TODO: improve handling of multiple tab elements

function init() {
    const tabs = document.querySelectorAll('[data-tabs]');

    tabs.forEach((tabGroup, i) => {
        let activeTab;
        let activeContent;

        tabGroup.dataset.tabs = i;

        const instance = new Tabby(`[data-tabs="${i}"]`);
        instance.setup();

        const killTabs = () => {
            if (!activeTab || !activeContent) return;

            activeTab.style.marginBottom = null;
            activeContent.style.top = null;
            activeContent.style.minHeight = null;
            instance.setup();
            tabGroup.removeAttribute('data-open');

            if (!mediaQuery.matches) {
                const headerOffset = 100;
                window.scrollTo(
                    0,
                    window.pageYOffset +
                        tabGroup.getBoundingClientRect().top -
                        headerOffset
                );
            }
        };

        tabGroup.addEventListener(
            'tabby',
            (event) => {
                const {
                    detail: { tab, content, previousTab },
                } = event;

                tabGroup.dataset.open = true;

                if (previousTab) previousTab.style.marginBottom = null;

                activeTab = tab;
                activeContent = content.firstElementChild;

                // FIXME: force redraw on IE11 by changing some random style
                const container = tabGroup.parentElement;
                container.style.fontFamily = 'inherit';

                const tabBounds = activeTab.parentElement.getBoundingClientRect();
                const parentBounds = tab.parentElement.parentElement.getBoundingClientRect();
                const contentBounds = activeContent.getBoundingClientRect();
                const hrBounds = tab
                    .querySelector('hr')
                    .getBoundingClientRect();
                const titleHeight = hrBounds.bottom - tabBounds.top;
                const tabMargin = parseInt(
                    getComputedStyle(activeTab.parentElement).marginTop,
                    10
                );

                const heightDifference =
                    contentBounds.height - tabBounds.height + tabMargin;
                const distanceToParent = tabBounds.top - parentBounds.top;

                tab.style.marginBottom = `calc(${heightDifference}px + ${titleHeight}px)`;
                activeContent.style.top = `calc(${distanceToParent}px + ${titleHeight}px)`;

                activeContent.style.minHeight = mediaQuery.matches
                    ? `calc(100% - ${titleHeight}px)`
                    : null;

                if (!window.matchMedia('(min-width: 992px)').matches) {
                    const headerOffset = 100;
                    window.scrollTo(
                        0,
                        window.pageYOffset + tabBounds.top - headerOffset
                    );
                }
            },
            false
        );

        [...tabGroup.querySelectorAll('a[id^="tabby-"]')]
            .map((x) => document.querySelector(x.getAttribute('href')))
            .map((x) => x.querySelector('.js-tab__close'))
            .forEach((button) => button.addEventListener('click', killTabs));

        mediaQuery.addListener(killTabs);
    });
}

export default {
    init,
};
